import { Component } from '@angular/core';

@Component({
  selector: 'app-send-docs',
  templateUrl: './send-docs.component.html',
  styleUrl: './send-docs.component.scss',
})
export class SendDocsComponent {
  docsItems = [
    { title: ' إرسال مستندات لإتمام الخدمات', image: 'assets/allServices/carouselsec.jpg' },

  ];
}
